export default __webpack_public_path__ + "static/media/mp.84dd28b0.jpg";